'use strict';exports.__esModule = true;exports.formatCompanyDataForEditRequest = exports.formatCompanyInitialValues = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _constants = require('../../constants');
var _components = require('../../components');
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}




var companyOmitFields = ['updated_at', 'created_at', 'owner_id', 'search', 'page', 'id'];

var defaultLanguage = (0, _get2.default)(_constants.language, 'default', '');

var formatAdvantages = function formatAdvantages() {var advantages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var formatted = [].concat(advantages);

  if (!formatted.length) {
    for (var idx = 0; idx < 3; idx += 1) {
      formatted.push({ id: 'advantage_' + idx });
    }
  } else {
    formatted = advantages.map(function (item, idx) {return Object.assign({}, item, { id: 'advantage_' + idx });});
  }

  return formatted;
};

var formatAddress = function formatAddress(address, locale) {
  var localizedAddress = (0, _get2.default)(address, locale) || (0, _get2.default)(address, defaultLanguage);
  return (0, _get2.default)(localizedAddress, 'city_name') + ', ' + (0, _get2.default)(localizedAddress, 'street_name') + ' ' + (0, _get2.default)(localizedAddress, 'house_number');
};

var formatBranches = function formatBranches(branches, locale) {
  var formatted = branches.map(function (branch) {return {
      name: branch.name,
      hide_house_number: branch.hide_house_number,
      address: formatAddress(branch.address, locale) };});

  return formatted;
};

var formatRealtors = function formatRealtors(realtors) {return realtors.map(function (item) {
    var imageObject = _components.UploadAssetWidget.convertLinkToImageObject(item.image);
    var image = _components.UploadAssetWidget.formatInitialImages([imageObject])[0];

    return Object.assign({},
    item, {
      image: image });

  });};

var formatImage = function formatImage() {var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return { link: image.link, angle: image.angle, description: image.description };};

var formatCompanyInitialValues = exports.formatCompanyInitialValues = function formatCompanyInitialValues(companyData, locale) {
  if (!companyData) {return null;}var _companyData$advantag =
  companyData.advantages,advantages = _companyData$advantag === undefined ? [] : _companyData$advantag,_companyData$realtors = companyData.realtors,realtors = _companyData$realtors === undefined ? [] : _companyData$realtors;
  var initialValues = Object.assign({}, companyData);

  if (initialValues.phone_number) {
    initialValues.phone_number = (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(initialValues.phone_number);
  }

  initialValues.advantages = formatAdvantages(advantages);

  return initialValues;
};

var formatCompanyDataForEditRequest = exports.formatCompanyDataForEditRequest = function formatCompanyDataForEditRequest(companyData, initialData) {
  var unchangedFields = Object.keys(companyData).reduce(function (acc, key) {
    var currentValue = companyData[key];
    var initialValue = initialData[key];

    if ((0, _isEqual2.default)(currentValue, initialValue)) {
      acc.push(key);
    }
    return acc;
  }, []);

  var formatted = Object.assign({}, (0, _omit2.default)(companyData, [].concat(companyOmitFields, unchangedFields)));

  if (formatted.additional_info) {
    Object.keys(formatted.additional_info).forEach(function (key) {
      var value = formatted.additional_info[key];
      formatted.additional_info[key] = value || null;
    });
  }

  if (formatted.branches && formatted.branches.length === 1) {
    formatted.branches = [{
      address: (0, _get2.default)(formatted, 'branches[0].address'),
      hide_house_number: (0, _get2.default)(formatted, 'branches[0].hide_house_number'),
      place_id: (0, _get2.default)(formatted, 'branches[0].place_id'),
      name: companyData.name }];

  }

  formatted.advantages = formatted.advantages && formatted.advantages.reduce(function (acc, advantage) {
    if (!!(0, _get2.default)(advantage, 'description.' + _constants.language.default)) {
      acc.push((0, _omit2.default)(advantage, 'id'));
    }
    return acc;
  }, []);

  formatted.image = formatted.image && formatImage(formatted.image);
  formatted.images = formatted.images && formatted.images.map(formatImage) || [];

  return formatted;
};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EditCompanyByOwner/helpers.js
// module id = 1239
// module chunks = 0